<template>
  <aside class="follow-up-rating-summary" aria-label="ملخص تقييم الطالب" aria-live="polite">
    <div class="row g-3">
      <div class="col-lg-4">
        <h3>متوسط التقييم</h3>
        <div class="follow-up-average" data-testid="overall-rating">
          <FollowUpRating :model-value="summary.average_rating" readonly />
          <strong v-if="summary.average_rating != null" dir="ltr">{{ formatAverage(summary.average_rating) }} / 5</strong>
        </div>
      </div>
      <div class="col-lg-8">
        <h3>متوسط التقييم حسب نوع المتابعة</h3>
        <dl v-if="summary.by_type.length" class="follow-up-type-averages">
          <div v-for="type in summary.by_type" :key="type.follow_up_type_id" class="follow-up-type-average">
            <dt>{{ type.name }}</dt>
            <dd class="follow-up-average">
              <FollowUpRating :model-value="type.average_rating" readonly />
              <strong v-if="type.average_rating != null" dir="ltr">{{ formatAverage(type.average_rating) }} / 5</strong>
            </dd>
          </div>
        </dl>
        <p v-else class="text-muted mb-0">لا يوجد تقييم</p>
      </div>
    </div>
  </aside>
</template>

<script>
import FollowUpRating from './FollowUpRating.vue';

export default {
  components: { FollowUpRating },
  props: { summary: { type: Object, required: true } },
  methods: {
    formatAverage(value) { return Number(value).toFixed(1); },
  },
};
</script>

<style scoped>
.follow-up-rating-summary { margin-bottom: 1.5rem; padding: 1rem; border: 1px solid var(--surface-border); border-inline-start: 3px solid var(--gold); border-radius: .75rem; background: var(--surface-raised); color: var(--text-primary); }
h3 { font-size: 1rem; font-weight: 700; margin: 0 0 .75rem; color: var(--text-primary); }
.follow-up-average { display: flex; flex-wrap: wrap; align-items: center; gap: .25rem .75rem; }
.follow-up-average strong { white-space: nowrap; font-variant-numeric: tabular-nums; }
.follow-up-type-averages { margin: 0; }
.follow-up-type-average { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: .5rem 1rem; padding: .6rem 0; border-bottom: 1px solid var(--surface-border); }
.follow-up-type-average:first-child { padding-top: 0; }
.follow-up-type-average:last-child { border-bottom: 0; padding-bottom: 0; }
dt { flex: 1 1 10rem; min-width: 0; overflow-wrap: anywhere; font-weight: 500; }
dd { margin: 0; }
</style>
